// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Msi7","content":"styles_content__T-TqP","row":"styles_row__pQIW2","footer":"styles_footer__2MZi3","phraseLength":"styles_phraseLength__Ge7l_"};